import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import { deleteRating } from "../api/supplier-performance-api";
import { showToast } from "utils/helpers";

interface UseDeleteRatingOptions {
	onSuccess?: () => void;
}

export const useDeleteRating = (options?: UseDeleteRatingOptions) => {
	const companyId = useCurrentCompanyId();
	const queryClient = useQueryClient();

	return useMutation<void, Error, number>({
		mutationFn: async (ratingId: number) => {
			await deleteRating(ratingId);
		},
		onSuccess: () => {
			if (companyId) {
				queryClient.invalidateQueries({
					queryKey: ["my-suppliers", companyId],
				});
				queryClient.invalidateQueries({
					queryKey: ["supplier-detail", companyId],
				});
				queryClient.invalidateQueries({
					queryKey: ["supplier-ratings", companyId],
				});
			}
			showToast("Rating deleted successfully", "Success", true);
			options?.onSuccess?.();
		},
		onError: () => {
			showToast(
				"Failed to delete rating. Please try again.",
				"Error"
			);
		},
	});
};
